import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {AuthService} from '@app/core/services/auth.service';

@Injectable()
export class UserGuard implements CanActivate {

	constructor(public authService: AuthService) {
	}

	public canActivate(): boolean {
		return !this.authService.currentUser.isAdmin();
	}

}
